import { render, staticRenderFns } from "./createBankForm.vue?vue&type=template&id=605f9725&"
import script from "./createBankForm.vue?vue&type=script&lang=js&"
export * from "./createBankForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports